import React, { Component, RefObject } from "react";
import echarts from "echarts/lib/echarts";
import "echarts/lib/chart/line";
// 引入提示框和标题组件
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/grid";

interface iProps {
  params: any;
}

export default class normalLine extends Component<iProps> {
  private normalLine: RefObject<HTMLDivElement>;
  constructor(props: any) {
    super(props);
    this.normalLine = React.createRef();
  }
  draw() {
    const myChart = echarts.init(this.normalLine.current);
    myChart.clear();
    const options = {
      grid: this.props.params.grid,
      tooltip: {
        show: true,
      },
      legend: {
        show: true,
        // orient: this.props.params.legendOrient,
        x: "center",
        bottom: "10",
        data: this.props.params.legends,
        textStyle: {
          color: "rgba(0,0,0,.65)",
          fontSize: 12,
        },
      },
      xAxis: {
        boundaryGap: true, // 坐标轴两边留白
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
        axisLabel: {
          textStyle: {
            fontSize: 12,
            color: "rgba(0,0,0,.65)",
          },
        },
        axisLine: {
          lineStyle: {
            color: "#E9E9E9",
          },
        },
        data: this.props.params.xAxis,
      },
      yAxis: [
        {
          name: "人数",
          type: "value",
          nameTextStyle: {
            color: "rgba(0,0,0,.65)",
            fontSize: "12",
          },
          minInterval: 1,
          splitLine: {
            // 网格线 y轴对应的是否显示
            show: true,
            lineStyle: {
              type: "dotted",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            formatter: "{value}",
            fontSize: 12,
            color: "rgba(0,0,0,.65)",
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#D7E7FD",
            },
          },
        },
        {
          name: "累计测温",
          type: "value",
          nameTextStyle: {
            color: "rgba(0,0,0,.65)",
            fontSize: "12",
          },
          minInterval: 1,
          splitLine: {
            // 网格线 y轴对应的是否显示
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            formatter: "{value}",
            fontSize: 12,
            color: "rgba(0,0,0,.65)",
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#D7E7FD",
            },
          },
        },
      ],
      series: this.props.params.series,
    };
    myChart.setOption(options, true);
    window.addEventListener("resize", () => {
      myChart.resize();
    });
  }
//   componentWillReceiveProps(){
//     this.draw();
//   }
//   componentDidMount(){
//       console.log(this.normalLine.current.offsetHeight)
//     this.draw();
//   }
  componentDidUpdate(prevProps) {
    // console.log("componentDidUpdate")
    this.draw();
  }
  render() {
    let { params } = this.props;
    return (
        <div
          ref={this.normalLine}
          className="normalLine"
        //   style={{ width: params.width, height: params.height }}
        ></div>
    );
  }
}
